import { useState } from "react";
import { useScrolled } from "@/hooks/useScrolled";
import Logo from "@/components/feature/Logo";

const navLinks = [
  { label: "Início", href: "#inicio" },
  { label: "Ocean", href: "#ocean" },
  { label: "Atuação", href: "#atuacao" },
  { label: "Portfólio", href: "#portfolio" },
  { label: "Como trabalhamos", href: "#como-trabalhamos" },
  { label: "Contato", href: "#contato" },
];

export default function Header() {
  const scrolled = useScrolled(40);
  const [open, setOpen] = useState(false);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "border-b border-accent-500/15 bg-primary-950/92 backdrop-blur-md"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-20 w-full max-w-[1440px] items-center justify-between px-4 md:px-8 lg:px-12">
        <a href="#inicio" aria-label="Ocean Companhia de Comércio — início" className="cursor-pointer">
          <Logo variant="light" size="md" />
        </a>

        <nav className="hidden items-center gap-7 lg:flex xl:gap-9" aria-label="Navegação principal">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="ocean-label cursor-pointer whitespace-nowrap text-[11px] text-background-100/75 transition-colors duration-300 hover:text-accent-300"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <button
          type="button"
          onClick={() => setOpen(true)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center text-background-50 lg:hidden"
          aria-label="Abrir menu"
          aria-expanded={open}
        >
          <i className="ri-menu-line text-2xl"></i>
        </button>
      </div>

      <div className={`fixed inset-0 z-[60] lg:hidden ${open ? "" : "pointer-events-none"}`} aria-hidden={!open}>
        <div
          className={`absolute inset-0 bg-primary-950/70 backdrop-blur-sm transition-opacity duration-300 ${
            open ? "opacity-100" : "opacity-0"
          }`}
          onClick={() => setOpen(false)}
        />
        <aside
          className={`absolute right-0 top-0 flex h-full w-[86%] max-w-sm flex-col border-l border-accent-500/20 bg-primary-950 px-7 py-7 transition-transform duration-500 ease-editorial ${
            open ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="flex items-center justify-between">
            <Logo variant="light" size="sm" />
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center text-background-50"
              aria-label="Fechar menu"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>

          <nav className="mt-14 flex flex-col gap-1" aria-label="Navegação mobile">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="border-b border-background-100/10 py-4 font-heading text-2xl text-background-50 transition-colors duration-300 hover:text-accent-300"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="mt-auto pt-10">
            <p className="ocean-label text-[10px] text-accent-400/80">Comercial</p>
            <a
              href="mailto:comercial@oceancompanhia.com.br"
              className="mt-2 block break-all text-sm text-background-100/80 transition-colors hover:text-accent-300"
            >
              comercial@oceancompanhia.com.br
            </a>
          </div>
        </aside>
      </div>
    </header>
  );
}